
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';

export interface CancelTeamInvitationRequest {
    companyId: string;
    invitationId: string;
}

/**
 * 
 */
export class PublicTeamInvitationApi extends runtime.BaseAPI {

    /**
     * GET /client-settings/api/team/invitations/cancel
          */
    async cancelTeamInvitationRaw(requestParameters: CancelTeamInvitationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['companyId'] == null) {
            throw new runtime.RequiredError(
                'companyId',
                'Required parameter "companyId" was null or undefined when calling cancelTeamInvitation().'
            );
        }

        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling cancelTeamInvitation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['invitationId'] != null) {
            queryParameters['invitationId'] = requestParameters['invitationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/client-settings/api/team/invitations/cancel`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * GET /client-settings/api/team/invitations/cancel
          */
    async cancelTeamInvitation(companyId: string, invitationId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelTeamInvitationRaw({ companyId: companyId, invitationId: invitationId }, initOverrides);
    }

}
